import api from "./api";

export const checkToken = async () => {
  try {
    const response = await api.get('/master/users/check');
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const logoutUser = async () => {
  try {
    const response = await api.post('/master/users/logout');
    return response.data;
  } catch (error) {
    console.error("There was an error logging out:", error);
    throw error;
  }
}

export const loginUser = async (data) => {
  try {
    const response = await api.post('/master/users/login', data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}
